import { apiEndpoint } from '../../config/app';
import createRestApiClient from '../utils/createRestApiClient';

export default () =>{
    const client = createRestApiClient().withConfig({ baseURL: apiEndpoint });
    return {
        subscribe: (plan) => client.request({
            method: 'POST',
            url: `/billing/subscribe`,
            data: {
                plan: plan
            }
        }),
        buyCredits: () => client.request({
            method: 'POST',
            url: `/billing/credits/charge`
        }),
        installTheme: (theme)=>client.request({
            method: 'POST',
            url: `/billing/themes/install`,
            data: theme
        }),
        installThemes: (themes, config)=>client.request({
            method: 'POST',
            url: `/billing/themes/install-batch`,
            data: { themes, config }
        }),
        unsubscribe: () => client.request({
            method: 'POST',
            url: `/billing/unsubscribe`
        }),
        dismissReview: (resetCounter) => client.request({
            method: 'POST',
            url: `/billing/review-dismiss`,
            data: { resetCounter }
        })
    };
};


// WEBPACK FOOTER //
// app/services/billing.js